import { Route, Redirect } from "react-router-dom";
import Cookie from "js-cookie";
import { isSessionExpired, expireSession } from "./Functionalities/sessionManager";
import { is_accountant_only } from "./Functionalities/Config";
import { ACCOUNTANT_HOME, accountantMayOpen } from "./Functionalities/accountantAccess";

const PrivateRoute = ({ component: Component, ...rest }) => {
  const isInvalid = !Cookie.get("foodoor_token") || isSessionExpired();
  if (isInvalid) {
    expireSession();
  }
  if (!isInvalid && is_accountant_only && !accountantMayOpen(rest.path)) {
    return <Redirect to={ACCOUNTANT_HOME} />;
  }

  return (
    <Route
      {...rest}
      component={(props) =>
        !isInvalid ? (
          <Component {...props} />
        ) : (
          <Redirect to="/login" />
        )
      }
    />
  );
};

export default PrivateRoute;
